<template>
  <div>
    <validation-observer ref="phonelineForm">
      <b-form-radio-group
          v-model="CHECKOUT_DATA.phoneline.option"
          stacked
          @input="updateAppointmentOption"
      >
        <b-form-radio value="1">
          Neuanschluss.
        </b-form-radio>

<!--        <div v-if="CHECKOUT_DATA.phoneline.option == 1" class="mt-1">-->
<!--          <div class="inner-section">-->
<!--            <p>-->
<!--              <strong>Falls Vormieter bekannt, bitte angeben:</strong>-->
<!--            </p>-->

<!--            <b-row>-->
<!--              <b-col md="6">-->
<!--                <b-form-group label="Vorname" label-for="phoneline-new-firstname">-->
<!--                  <b-form-input-->
<!--                      id="phoneline-new-firstname"-->
<!--                      v-model="CHECKOUT_DATA.phoneline.firstname"-->
<!--                      placeholder="Bitte geben Sie den Voramen an."-->
<!--                  />-->
<!--                </b-form-group>-->
<!--              </b-col>-->
<!--              <b-col md="6">-->
<!--                <b-form-group label="Name" label-for="phoneline-new-name">-->
<!--                  <b-form-input-->
<!--                      id="phoneline-new-name"-->
<!--                      v-model="CHECKOUT_DATA.phoneline.name"-->
<!--                      placeholder="Bitte geben Sie den Namen an."-->
<!--                  />-->
<!--                </b-form-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </div>-->
<!--          <hr>-->
<!--        </div>-->

        <b-form-radio value="2" style="margin-top: 5px">
          Vorheriger Anschluss bereits gekündigt.
        </b-form-radio>

        <div v-if="CHECKOUT_DATA.phoneline.option == 2" class="mt-1">
          <div class="inner-section">
            <b-form-group label="Kündigungsdatum" label-for="phoneline-terminated-date"  class="required">
              <validation-provider
                  #default="{ errors }"
                  name="Kündigungsdatum"
                  rules="required"
                  vid="Kündigungsdatum"
              >
                <b-form-datepicker
                    v-model="CHECKOUT_DATA.phoneline.termination_date"
                    id="phoneline-terminated-date"
                    placeholder="Wählen Sie bitte das Kündigungsdatum aus."
                    local="de"
                    format="DD.MM.YYYY"
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <validation-provider
                #default="{ errors }"
                name="Bisheriger Anbieter"
                rules="required"
                vid="current-provider"
            >
              <b-form-group label="Bisheriger Anbieter" label-for="phoneline-takeover-provider" class="required">
                <v-select
                    id="phoneline-new-name"
                    v-model="CHECKOUT_DATA.phoneline.provider"
                    input-id="address-city"
                    :options="providers"
                    placeholder="Bitte wählen Sie Ihren bisherigen Anbieter aus."
                />

                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <b-form-group  class="required" v-if="CHECKOUT_DATA.phoneline.provider && CHECKOUT_DATA.phoneline.provider.value == 'other'" label="Anderer Anbieter" label-for="phoneline-terminated-date">
              <validation-provider
                  #default="{ errors }"
                  name="Anderer Anbieter"
                  rules="required"
                  vid="Anderer Anbieter"
              >
                <b-form-input
                    id="phoneline-other-provider"
                    v-model="CHECKOUT_DATA.phoneline.provider_other"
                    placeholder="Bitte geben Sie den Namen Ihres bisherigen Anbieters an."
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <hr>
        </div>

        <ValidationProvider rules="" vid="phoneline_takeover_active">
          <b-form-radio value="3" style="margin-top: 5px">
            Ich möchte, dass Cable 4 meinen Anschluss beim bisherigen Anbieter kündigt. Voraussetzung für Rufnummernmitnahme/Rufnummernportierung!
          </b-form-radio>
        </ValidationProvider>

        <div v-if="CHECKOUT_DATA.phoneline.option == 3" class="mt-1">
          <div class="inner-section">
            <validation-provider
                #default="{ errors }"
                name="bisheriger Anbieter"
                rules="required"
                vid="current-provider"
            >
              <b-form-group label="bisheriger Anbieter" label-for="phoneline-takeover-provider" class="required">
                <v-select
                    id="phoneline-new-name"
                    v-model="CHECKOUT_DATA.phoneline.provider"
                    input-id="address-city"
                    :options="providers"
                    placeholder="Bitte wählen Sie Ihren bisherigen Anbieter aus."
                />

                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <b-form-group  class="required" v-if="CHECKOUT_DATA.phoneline.provider && CHECKOUT_DATA.phoneline.provider.value == 'other'" label="Anderer Anbieter" label-for="phoneline-terminated-date">
              <validation-provider
                  #default="{ errors }"
                  name="Anderer Anbieter"
                  rules="required"
                  vid="Anderer Anbieter"
              >
                <b-form-input
                    id="phoneline-other-provider"
                    v-model="CHECKOUT_DATA.phoneline.provider_other"
                    placeholder="Bitte geben Sie den Namen Ihres bisherigen Anbieters an."
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <p class="mt-2">
              <strong>Anschlussinhaber laut Vertrag beim bisherigen Anbieter (falls abweichend)</strong>
            </p>

            <div class="p-1 bg-light mb-2">
              <p class="font-weight-bolder mb-0">Wichtiger Hinweis:</p>
              Wenn der bisherige Anschlussinhaber nicht mit dem Kunden übereinstimmt, benötigen wir die abweichenden Angaben. Bitte übernehmen Sie die exakte Schreibweise vom bisherigen Anbieter, auch mit eventuellen Schreibfehlern (siehe Rechnung)!
            </div>

            <b-row>
              <b-col md="6">
                <b-form-group label="Vorname" class="required" label-for="phoneline-owner-firstname">
                  <validation-provider
                      #default="{ errors }"
                      name="Vorname"
                      rules="required|max:30"
                      vid="phoneline-owner-firstname"
                  >
                  <b-form-input
                      id="phoneline-owner-firstname"
                      v-model="CHECKOUT_DATA.phoneline.owner_firstname"
                      placeholder="Bitte geben Sie den Vornamen an."
                  />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Name" class="required" label-for="phoneline-owner-name">
                  <validation-provider
                      #default="{ errors }"
                      name="Name"
                      rules="required|max:30"
                      vid="phoneline-owner-name"
                  >
                  <b-form-input
                      id="phoneline-owner-name"
                      v-model="CHECKOUT_DATA.phoneline.owner_name"
                      placeholder="Bitte geben Sie den Namen an."
                  />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Straße und Hausnummer" class="required" label-for="phoneline-owner-street">
                  <validation-provider
                      #default="{ errors }"
                      name="Straße und Hausnummer"
                      rules="required"
                      vid="phoneline-owner-street"
                  >
                  <b-form-input
                      id="phoneline-owner-street"
                      v-model="CHECKOUT_DATA.phoneline.owner_street"
                      placeholder="Bitte geben Sie die Straße und Hausnummer an."
                  />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="PLZ" class="required" label-for="phoneline-owner-postal">
                  <validation-provider
                      #default="{ errors }"
                      name="PLZ"
                      rules="required"
                      vid="phoneline-owner-postal"
                  >
                  <b-form-input
                      id="phoneline-owner-postal"
                      v-model="CHECKOUT_DATA.phoneline.owner_postal"
                      placeholder="Bitte geben Sie die PLZ an."
                  />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="9">
                <b-form-group label="Ort" class="required" label-for="phoneline-owner-city">
                  <validation-provider
                      #default="{ errors }"
                      name="Ort"
                      rules="required"
                      vid="phoneline-owner-city"
                  >
                  <b-form-input
                      id="phoneline-owner-city"
                      v-model="CHECKOUT_DATA.phoneline.owner_city"
                      placeholder="Bitte geben Sie den Ort an."
                  />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <ValidationProvider
                #default="{ errors }"
                :rules="{ required: { allowFalse: false } }"
            >
              <b-form-group
                  class="required"
                  label="Ermächtigung"
                  label-for="phoneline-takeover-terms"
              >
                <b-form-checkbox
                    class="mb-1"
                    v-model="CHECKOUT_DATA.phoneline.terms"
                >
                  Ich bevollmächtige Cable 4, die erforderliche Kündigung beim derzeitigen Anbieter für mich vorzunehmen.
                  Bei Verschiebung des Wechseltermins bin ich damit einverstanden, dass der Vertrag mit meinem
                  derzeitigen Anbieter fortgesetzt wird, bis der Wechsel erfolgreich durchgeführt wurde. Hinweis: Verträge für den Internetzugang,
                  Preselection o. ä. sind vom Kunden zu kündigen. Verträge für den Internetzugang werden gekündigt,
                  sofern der Anschlussinhaber mit dem des Telefonanschlusses übereinstimmt.
                </b-form-checkbox>
              </b-form-group>

              <small v-if="errors.length > 0" class="text-danger mb-1 d-inline-block"
                     :class="{'has-errors': errors.length > 0}">
                Bitte akzeptieren Sie die Ermächtigung.
              </small>
            </ValidationProvider>

            <hr>
            <b-button variant="primary" size="sm" @click="copyAdressData">Kontaktdaten vom Vertragspartner übernehmen</b-button>
          </div>

        </div>
      </b-form-radio-group>


<!--      <hr>-->
<!--      <p>-->
<!--        <strong>Künftiger Telefonanschluss</strong>-->
<!--      </p>-->
<!--      <b-form-checkbox-->
<!--          class="mb-1"-->
<!--          v-model="CHECKOUT_DATA.phoneline.new_numbers"-->
<!--      >-->
<!--        Neue Rufnummern-->
<!--      </b-form-checkbox>-->

      <div v-if="CHECKOUT_DATA.phoneline.new_numbers">
        <div class="inner-section">
          <b-form-group
              label="Anzahl neuer Rufnummern"
              label-for="phoneline-takeover-numbers-count"
          >
            <b-form-select
                id="phoneline-takeover-numbers-count"
                :options="getPhoneLineOptions()"
                value="1"
                v-model="CHECKOUT_DATA.phoneline.count_new_numbers"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormRadio, BRow, BCol, BFormInput, BFormCheckbox,
  BFormSelect, BAvatar, VBTooltip
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, required_if, email, digits} from '@validations'

export default {
  name: "PhonelineSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BFormSelect,
    BAvatar,
    vSelect
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      address: {},
      value: [],
      showMoreNumbers: false,
      providers: [
        {value: "01", label: "Deutsche Telekom"},
        {value: "02", label: "Vodafone DSL"},
        {value: "03", label: "Vodafone Kabel"},
        {value: "04", label: "1&1"},
        {value: "05", label: "o2 Telefónica"},
        {value: "other", label: "Anderer Anbieter"},
      ]
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'BILLING_ADDRESS']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.phonelineForm.validate()
    },
    getPhoneLineOptions() {
      let data = []

      if (this.SERVICE.hasPhone) {
        for (let i = 1; i <= this.SERVICE.phone.channels; i++) {
          data.push({
            value: i,
            text: i
          })
        }
      }

      return data
    },
    copyAdressData() {
      this.CHECKOUT_DATA.phoneline.owner_firstname = this.BILLING_ADDRESS.firstname
      this.CHECKOUT_DATA.phoneline.owner_name = this.BILLING_ADDRESS.name
      this.CHECKOUT_DATA.phoneline.owner_street = this.BILLING_ADDRESS.street + ' ' + this.BILLING_ADDRESS.housenumber
      this.CHECKOUT_DATA.phoneline.owner_postal = this.BILLING_ADDRESS.postcode
      this.CHECKOUT_DATA.phoneline.owner_city = this.BILLING_ADDRESS.city
    },
    updateAppointmentOption(value) {
      if (value == 1 && this.CHECKOUT_DATA.appointment == 3) {
        this.CHECKOUT_DATA.appointment = 1
      }
    }

  }
}
</script>

<style scoped>
.question-mark {
  background: #000;
  width: 1rem;
  height: 1rem;
  position: relative;
  top: -2px;
}

.tooltip-inner {
  max-width: 240px;
}
</style>
